import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface IIsDataMonitoringAdminUIEnabledParams {}

export class IsDataMonitoringAdminUIEnabledRequest extends Request<
  IIsDataMonitoringAdminUIEnabledParams,
  boolean
> {
  constructor(params: IIsDataMonitoringAdminUIEnabledParams) {
    super('isDataMonitoringAdminUIEnabled', params);
  }
}
